export const listTransformation = (payload: any, optionMeasureUnits: any, optionGenericMeasureTypes: any) => {
  const getMeasureTypeId: [] = payload.map((item: any) => item.measureTypeId);
  const dataArray: any = new Set(getMeasureTypeId);
  const uniqueMeasureTypeId = [...dataArray];
  const dataArraySort = uniqueMeasureTypeId.sort((prev: any, next: any) => {
    return prev - next;
  })
  const list = dataArraySort.map((item: any) => {
    return payload.filter((element: any) => element.measureTypeId === item);
  });
  return normalizeRules(list, optionMeasureUnits, optionGenericMeasureTypes);
};

const normalizeRules = (list: any, optionMeasureUnits: any, optionGenericMeasureTypes: any) => {
  return list.map((itemList: any) => {
    itemList.map((item: any) => {
      Object.assign(item,
        { measureTypeText: optionGenericMeasureTypes?.find((type: any) => Number(type.value) === item.measureTypeId)?.label ?? '' },
        { measureUnit: optionMeasureUnits?.find((type: any) => Number(type.value) === item.measureUnitId)?.label ?? '' }
      );
      return item;
    })
    return itemList;
  })
}